import * as React from 'react';
import { ReactNode } from 'react';

import { Bem } from '../../service/Bem/Bem';

import './Badge.css';

export enum BadgeTheme {
    red = 'red'
}

interface BadgeProps {
    children: ReactNode;
    theme: BadgeTheme;
}

export const Badge = ({ children, theme }: BadgeProps) => (
    <span
        className={Bem.cls('badge', '', {
            theme
        })}
    >
        {children}
    </span>
);
